import { render, staticRenderFns } from "./BlockType22.vue?vue&type=template&id=5f68fb02&scoped=true"
import script from "./BlockType22.vue?vue&type=script&lang=ts"
export * from "./BlockType22.vue?vue&type=script&lang=ts"
import style0 from "./BlockType22.vue?vue&type=style&index=0&id=5f68fb02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f68fb02",
  null
  
)

export default component.exports